import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCircleCheck,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";

import "./messageContainer.css";
import { useState } from "react";

const MessageContainer = ({ data }) => {
  const [visibility, setVisibility] = useState(true);
  const { heading, message, positive } = data;

  function closePopup() {
    setVisibility(false);
  }

  return visibility ? (
    <div
      className={
        "popup-container" +
        (positive ? " positive bg-green" : " negative bg-red")
      }
    >
      <div className={"popup-container-header"}>
        <div className="popup-container-header-heading">
          <h6>{heading}</h6>
          <div className="popup-message-symbol">
            {positive ? (
              <div className={"positve-message-symbol"}>
                <FontAwesomeIcon icon={faCircleCheck} />
              </div>
            ) : (
              <div className="negative-message-symbol ">
                <FontAwesomeIcon icon={faCircleExclamation} />
              </div>
            )}
          </div>
        </div>
        <div className="popup-close-icon" onClick={closePopup}>
          <FontAwesomeIcon className="fa-xs close-icon-svg" icon={faTimes} />
        </div>
      </div>
      <div
        className={
          "popup-decoration-rect"
          // + (positive ? " bg-green" : " bg-red")
        }
      ></div>
      <div className={"popup-container-body"}>
        <div className="popup-container-message">
          <p>{message}</p>
        </div>
      </div>
    </div>
  ) : null;
};

export default MessageContainer;
